import React, { useRef, useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import style from './forms.mod.scss'
import { Content } from '@components'
import FormsDitchTheScales from './forms-ditch-the-scales'
import FormsContact from './forms-contact'
import { postSend } from '@helpers/gtmHelpers'
import smoothscroll from 'smoothscroll-polyfill'

const Form = ({
  heading,
  leadNode,
  successMessage = 'Thank you for your message, we will be in touch shortly.',
  formType,
  zapierWebhook
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const inputs = {
    type: useRef(null),
    subject: useRef(null),
    optIn: useRef(null),
    emailAddress: useRef(null)
  }

  useEffect(() => {
    smoothscroll.polyfill()
  }, [])

  const handleSubmit = async formData => {
    setIsSubmitting(true)
    setError(null)

    try {
      const makeWebhook =
        'https://hook.us1.make.com/ied49satsoomrxx1i4mgohrx6s7imzp3'

      const response = await fetch(makeWebhook, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })

      if (response.ok) {
        setSuccess(true)
        postSend(formData, formType, inputs, formType === 'Contact')
      } else {
        throw new Error('Form submission failed')
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <div className={style.form}>
        <h3>{heading}</h3>
        {leadNode?.childMarkdownRemark?.html && (
          <Content contentNode={leadNode} addLastMargin />
        )}
        {!error && !success && (
          <>
            {formType === 'Ditch the Scales' && (
              <FormsDitchTheScales
                inputs={inputs}
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
              />
            )}
            {formType === 'Contact' && (
              <FormsContact
                inputs={inputs}
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
              />
            )}
          </>
        )}
        {error && (
          <div className={style.form__error}>
            <p>{'Something went wrong. Please try again later.'}</p>
          </div>
        )}
        {success && (
          <div className={style.form__success}>
            <p>{successMessage}</p>
          </div>
        )}
      </div>
      {/* Misc Tracking fields */}
      <input type="hidden" name="type" ref={inputs.type} value={formType} />
    </>
  )
}

export default Form

export const query = graphql`
  fragment Form on DatoCmsForm {
    id
    model {
      apiKey
    }
    background
    heading
    formType
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    padding
    zapierWebhook
    successMessage
  }
`
